var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6124 9.9337C29.4616 9.36631 29.1644 8.84848 28.7506 8.43202C28.3368 8.01556 27.8209 7.71509 27.2545 7.56068C25.1694 7 16.835 7 16.835 7C16.835 7 8.50063 7 6.41552 7.56068C5.8491 7.71509 5.33318 8.01556 4.91939 8.43202C4.50559 8.84848 4.20843 9.36631 4.05765 9.9337C3.5 12.0279 3.5 16.3951 3.5 16.3951C3.5 16.3951 3.5 20.7623 4.05765 22.8565C4.20843 23.4239 4.50559 23.9417 4.91939 24.3582C5.33318 24.7747 5.8491 25.0751 6.41552 25.2295C8.50063 25.7902 16.835 25.7902 16.835 25.7902C16.835 25.7902 25.1694 25.7902 27.2545 25.2295C27.8209 25.0751 28.3368 24.7747 28.7506 24.3582C29.1644 23.9417 29.4616 23.4239 29.6124 22.8565C30.17 20.7623 30.17 16.3951 30.17 16.3951C30.17 16.3951 30.17 12.0279 29.6124 9.9337Z",
    fill: "#FF0302"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1074 20.361V12.4297L21.078 16.3953L14.1074 20.361Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.75371d1c7fd2368f26e10cbbf3c977c3.svg";
export { ForwardRef as ReactComponent };